<template>
  <v-layout>
    <d-header fluid>
      <h1 class="title">
        {{ $t("properties") }}
      </h1>
    </d-header>
    <d-data-table
      ref="data-table"
      fluid
      resource="properties"
      :searchable="false"
      :loading="loading"
      :scrollable="true"
      :parameters="parameters"
      default-sort-field="deleted_at"
      default-sort-order="asc"
      :delete-button="false"
      :edit-button="false"
    >
      <template #actions="{ row }">
        <button
          class="button is-small is-white"
          @click="confirmRestore(row)"
        >
          <div class="icon has-text-grey">
            <i class="mdi mdi-restore mdi-18px" />
          </div>
        </button>
      </template>

      <b-table-column
        v-slot="props"
        field="owner_business.name"
        :label="$t('owner_businesses').capitalize()"
      >
        <div
          v-if="!$roleCan([$laravel.role_client])"
          class="is-size-7"
        >
          <b-tooltip
            :label="$t('owner').capitalize() + ': ' + props.row.owner.name"
            type="is-black"
            position="is-right"
          >
            <router-link :to="`/owners/${props.row.owner.id}`">
              {{
                props.row.owner_business ? props.row.owner_business.name : ""
              }}
            </router-link>
          </b-tooltip>
        </div>

        <div
          v-if="$laravel.user.is_owner_contact || $laravel.user.owner_id"
          class="is-size-7"
        >
          <b-tooltip
            :label="$t('owner').capitalize() + ': ' + props.row.owner.name"
            type="is-black"
            position="is-right"
          >
            {{ props.row.owner_business ? props.row.owner_business.name : "" }}
          </b-tooltip>
        </div>
      </b-table-column>

      <b-table-column
        v-slot="props"
        field="address"
        :label="$t('address').capitalize()"
        sortable
      >
        <div class="is-flex">
          <div class="has-text-info has-text-weight-semibold is-size-7">
            {{ props.row.address.full_address }}
          </div>
        </div>
      </b-table-column>

      <b-table-column
        v-slot="props"
        field="address.address_2"
        :label="$t('address_2').capitalize()"
      >
        <div class="is-flex">
          <div class="is-size-7">
            {{ props.row.address.address_2 }}
          </div>
        </div>
      </b-table-column>

      <b-table-column
        v-slot="props"
        field="property_status_latest_type"
        :label="$t('status').capitalize()"
      >
        <div class="is-size-7">
          <div
            v-if="props.row.property_status_latest_type"
            class="tag"
          >
            {{ $t(props.row.property_status_latest_type).capitalize() }}
          </div>
        </div>
      </b-table-column>

      <b-table-column
        v-slot="props"
        field="type"
        :label="$t('housing_size').capitalize()"
        sortable
      >
        <div class="is-size-7">
          {{ $t(props.row.type) }}
        </div>
      </b-table-column>

      <b-table-column
        v-slot="props"
        field="property_status_asked_rent"
        :label="$t('asked_rent').capitalize()"
      >
        <div
          v-if="props.row.property_status_asked_rent"
          class="is-size-7"
        >
          {{ props.row.property_status_asked_rent }}$
        </div>
      </b-table-column>

      <b-table-column
        v-slot="props"
        field="status_availability_date"
        :label="$t('availability_date_show').capitalize()"
        sortable
      >
        <div
          v-if="props.row.latest_status"
          class="is-size-7"
        >
          <span v-if="props.row.availability_date">
            {{
              $dayjs(props.row.latest_status.availability_date)
                .utc()
                .format("LL")
            }}
          </span>
          <span v-else>-</span>
        </div>
      </b-table-column>

      <b-table-column
        v-slot="props"
        field="rent_agent_name"
        :label="$t('rent_agent_name').capitalize()"
      >
        <div v-if="props.row.latest_status">
          <div
            v-if="
              props.row.latest_status.rent_agents &&
                props.row.latest_status.rent_agents.length
            "
            class="is-flex gap-1 is-flex-wrap-wrap"
          >
            <span
              v-for="rent_agent in props.row.latest_status.rent_agents"
              :key="rent_agent.id"
            >
              <b-tooltip
                type="is-black"
                position="is-right"
                multilined
              >
                <img
                  class="is-30 is-avatar"
                  :src="rent_agent.avatar_url"
                >

                <template #content>
                  <div>
                    <p>
                      {{ rent_agent.name }}
                    </p>
                    <p>
                      {{ rent_agent.email }}
                    </p>
                  </div>
                </template>
              </b-tooltip>
            </span>
          </div>
          <span v-else> - </span>
        </div>
      </b-table-column>
      <b-table-column
        v-slot="props"
        field="deleted_at"
        :label="$t('deleted_at').capitalize()"
      >
        <span v-if="props.row.deleted_at">
          {{ $dayjs(props.row.deleted_at).utc().format("LL") }}
        </span>
      </b-table-column>
    </d-data-table>
  </v-layout>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: this.$t("properties"),
    };
  },
  data() {
    return {
      loading: false,
      parameters: {
        archived: true,
      },
    };
  },
  created() {},

  methods: {
    confirmRestore(row) {
      this.$buefy.dialog.confirm({
        title: this.$t("restore_property_title"),
        message: this.$t("restore_property_msg"),
        confirmText: this.$t("confirm"),
        cancelText: this.$t("cancel"),
        type: "is-success",
        onConfirm: () => {
          this.restore(row);
        },
      });
    },
    restore(property) {
      const formData = new FormData();
      formData.append("property_id", property.id);

      this.$http
        .post(route("api.property.restore"), formData)
        .then((response) => {
          this.loading = false;
          this.$refs["data-table"].loadData();
          notificator.open({
            message: response.data.message,
            type: "success",
          });
        })
        .catch((e) => {
          console.error(e);
        });
    },
  },
};
</script>

<style scoped>
.is-30 {
  width: 26px;
  height: 26px;
}
</style>
